"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TYPES_FAILURE = exports.TYPES_SUCCESS = exports.TYPES_REQUEST = exports.MODELS_FAILURE = exports.MODELS_SUCCESS = exports.MODELS_REQUEST = exports.BRANDS_FAILURE = exports.BRANDS_SUCCESS = exports.BRANDS_REQUEST = exports.RECEIVE_TYPES = exports.RECEIVE_MODELS = exports.RECEIVE_BRANDS = exports.SELECT_TYPE = exports.SELECT_MODEL = exports.SELECT_BRAND = undefined;
exports.loadBrands = loadBrands;
exports.selectBrand = selectBrand;
exports.selectModel = selectModel;
exports.selectType = selectType;

var _api = require("../middleware/api");

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var SELECT_BRAND = exports.SELECT_BRAND = "SELECT_BRAND";
var SELECT_MODEL = exports.SELECT_MODEL = "SELECT_MODEL";
var SELECT_TYPE = exports.SELECT_TYPE = "SELECT_TYPE";
var RECEIVE_BRANDS = exports.RECEIVE_BRANDS = "RECEIVE_BRANDS";
var RECEIVE_MODELS = exports.RECEIVE_MODELS = "RECEIVE_MODELS";
var RECEIVE_TYPES = exports.RECEIVE_TYPES = "RECEIVE_TYPES";
var BRANDS_REQUEST = exports.BRANDS_REQUEST = "BRANDS_REQUEST";
var BRANDS_SUCCESS = exports.BRANDS_SUCCESS = "BRANDS_SUCCESS";
var BRANDS_FAILURE = exports.BRANDS_FAILURE = "BRANDS_FAILURE";

function loadBrands(garageId) {
  return function (dispatch) {
    return dispatch(_defineProperty({}, _api.CALL_API, {
      types: [BRANDS_REQUEST, BRANDS_SUCCESS, BRANDS_FAILURE],
      endpoint: "/lists/vehicles/brands",
      method: "GET",
      authenticated: true,
      query: {
        GarageId: garageId,
        ContainsProducts: false
      }
    }));
  };
}

var MODELS_REQUEST = exports.MODELS_REQUEST = "MODELS_REQUEST";
var MODELS_SUCCESS = exports.MODELS_SUCCESS = "MODELS_SUCCESS";
var MODELS_FAILURE = exports.MODELS_FAILURE = "MODELS_FAILURE";

function selectBrand(garageId, brandId) {
  return function (dispatch) {
    dispatch({
      type: SELECT_BRAND,
      brandId: brandId
    });
    return dispatch(_defineProperty({}, _api.CALL_API, {
      types: [MODELS_REQUEST, MODELS_SUCCESS, MODELS_FAILURE],
      endpoint: "/lists/vehicles/brands/" + brandId + "/models",
      method: "GET",
      authenticated: true,
      query: {
        GarageId: garageId,
        ContainsProducts: false
      }
    }));
  };
}

var TYPES_REQUEST = exports.TYPES_REQUEST = "TYPES_REQUEST";
var TYPES_SUCCESS = exports.TYPES_SUCCESS = "TYPES_SUCCESS";
var TYPES_FAILURE = exports.TYPES_FAILURE = "TYPES_FAILURE";

function selectModel(garageId, modelId) {
  return function (dispatch, getState) {
    var brandId = getState().vehicleSelection.brandId;
    dispatch({
      type: SELECT_MODEL,
      modelId: modelId
    });
    return dispatch(_defineProperty({}, _api.CALL_API, {
      types: [TYPES_REQUEST, TYPES_SUCCESS, TYPES_FAILURE],
      endpoint: "/lists/vehicles/brands/" + brandId + "/models/" + modelId + "/types",
      method: "GET",
      authenticated: true,
      query: {
        GarageId: garageId,
        ContainsProducts: false
      }
    }));
  };
}

function selectType(typeId) {
  return {
    type: SELECT_TYPE,
    typeId: typeId
  };
}